import Vue from 'vue'
import Router from 'vue-router'
import yellowPage from '@/pages/yellowPage'
import userProtocol from '@/pages/userProtocol'
import praviteProtocol from '@/pages/praviteProtocol'
import broadcastProtocol from '@/pages/broadcastProtocol'
import masterInfo from '@/pages/masterInfo'
import reportInfo from '@/pages/reportInfo'
import videoInfo from '@/pages/videoInfo'
import chassroomInfo from '@/pages/chassroomInfo'
import interviewInfo from '@/pages/interviewInfo'
import companyInfo from '@/pages/companyInfo'
import associationInfo from '@/pages/associationInfo'
import needInfo from '@/pages/needInfo'
import organizationInfo from '@/pages/organizationInfo'
import activitiesInfo from '@/pages/activitiesInfo'
import workInfo from '@/pages/workInfo'
import releasedemand from '@/pages/releasedemand'
import releaseRecruit from '@/pages/releaseRecruit'
import special from '@/pages/special'
import pcGuide from '@/pages/pcGuide'
import sharemasterInfo from '@/share/sharemasterInfo'
import sharereportInfo from '@/share/sharereportInfo'
import sharevideoInfo from '@/share/sharevideoInfo'
import sharechassroomInfo from '@/share/sharechassroomInfo'
import shareinterviewInfo from '@/share/shareinterviewInfo'
import sharecompanyInfo from '@/share/sharecompanyInfo'
import shareneedInfo from '@/share/shareneedInfo'
import shareorganizationInfo from '@/share/shareorganizationInfo'
import shareactivitiesInfo from '@/share/shareactivitiesInfo'
import shareworkInfo from '@/share/shareworkInfo'
import shareyellowPage from '@/share/shareyellowPage'
import shareassociationInfo from '@/share/shareassociationInfo'
import shareuserCenter from '@/share/shareuserCenter'
import sharedown from '@/share/sharedown'
import shareTestPage from '@/share/shareTestPage'
import sharespecial from '@/share/sharespecial'
import sharepcGuide from '@/share/sharepcGuide'
import sharelivebroadcast from '@/share/sharelivebroadcast'
import shareRecordBroadcast from '@/share/shareRecordBroadcast' // 录播分享页面

import download from '@/components/download'


Vue.use(Router)
export default new Router({
  //mode: 'history', 
  routes: [
    {
      path: '/releasedemand',
      name: 'releasedemand',
      component: releasedemand
    },
    {
      path: '/special',
      name: 'special',
      component: special
    },
    {
      path: '/releaseRecruit',
      name: 'releaseRecruit',
      component: releaseRecruit
    },
    {
      path: '/download/transferStation',
      name: 'download',
      component: download
    },
    {
      path: '/workInfo',
      name: 'workInfo',
      component: workInfo
    },
    {
      path: '/activitiesInfo',
      name: 'activitiesInfo',
      component: activitiesInfo
    },
    {
      path: '/companyInfo',
      name: 'companyInfo',
      component: companyInfo
    },
    {
      path: '/needInfo',
      name: 'needInfo',
      component: needInfo
    },
    {
      path: '/organizationInfo',
      name: 'organizationInfo',
      component: organizationInfo
    },
  	{
      path: '/userProtocol',
      name: 'userProtocol',
      component: userProtocol
    },
  	{
      path: '/praviteProtocol',
      name: 'praviteProtocol',
      component: praviteProtocol
    },
    {
      path: '/broadcastProtocol',
      name: 'broadcastProtocol',
      component: broadcastProtocol
    },
    {
      path: '/masterInfo',
      name: 'masterInfo',
      component: masterInfo
    },
    {
      path: '/reportInfo',
      name: 'reportInfo',
      component: reportInfo
    },
    {
      path: '/videoInfo',
      name: 'videoInfo',
      component: videoInfo
    },
    {
      path: '/chassroomInfo',
      name: 'chassroomInfo',
      component: chassroomInfo
    },
    {
      path: '/interviewInfo',
      name: 'interviewInfo',
      component: interviewInfo
    },
    {
      path: '/yellowPage',
      name: 'yellowPage',
      component: yellowPage
    },
    {
      path: '/pcGuide',
      name: 'pcGuide',
      component: pcGuide
    },
    {
      path: '/associationInfo',
      name: 'associationInfo',
      component: associationInfo
    },
    {
      path: '/sharemasterInfo',
      name: 'sharemasterInfo',
      component: sharemasterInfo
    },
    {
      path: '/sharereportInfo',
      name: 'sharereportInfo',
      component: sharereportInfo
    },
    {
      path: '/sharevideoInfo',
      name: 'sharevideoInfo',
      component: sharevideoInfo
    },
    {
      path: '/sharechassroomInfo',
      name: 'sharechassroomInfo',
      component: sharechassroomInfo
    },
    {
      path: '/shareinterviewInfo',
      name: 'shareinterviewInfo',
      component: shareinterviewInfo
    },
    {
      path: '/sharecompanyInfo',
      name: 'sharecompanyInfo',
      component: sharecompanyInfo
    },
    {
      path: '/sharespecial',
      name: 'sharespecial',
      component: sharespecial
    },
    {
      path: '/sharepcGuide',
      name: 'sharepcGuide',
      component: sharepcGuide
    },
    {
      path: '/shareneedInfo',
      name: 'shareneedInfo',
      component: shareneedInfo
    },
    {
      path: '/sharelivebroadcast',
      name: 'sharelivebroadcast',
      component: sharelivebroadcast
    },
    {
      path: '/shareRecordBroadcast',
      name: 'shareRecordBroadcast',
      component: shareRecordBroadcast
    },
    {
      path: '/shareorganizationInfo',
      name: 'shareorganizationInfo',
      component: shareorganizationInfo
    },
    {
      path: '/shareactivitiesInfo',
      name: 'shareactivitiesInfo',
      component: shareactivitiesInfo
    },
    {
      path: '/shareassociationInfo',
      name: 'shareassociationInfo',
      component: shareassociationInfo
    },
    {
      path: '/shareyellowPage',
      name: 'shareyellowPage',
      component: shareyellowPage
    },
    {
      path: '/shareuserCenter',
      name: 'shareuserCenter',
      component: shareuserCenter
    },
    {
      path: '/sharedown',
      name: 'sharedown',
      component: sharedown
    },
    {
      path: '/shareTestPage',
      name: 'shareTestPage',
      component: shareTestPage
    },
    {
      path: '/shareworkInfo',
      name: 'shareworkInfo',
      component: shareworkInfo
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js